export default "__VITE_ASSET__Cw$HJM8v__"